import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFab } from "./WhatsAppFab";
import { CookieBanner } from "./CookieBanner";
import { whenIdle } from "@/lib/idle";
import { ROUTE_PRELOADERS } from "@/routes/registry";

/** Ramène la page en haut à chaque navigation. */
const useScrollTopOnNavigate = (key: string) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [key]);
};

/** Précharge en idle toutes les routes non encore visitées — UX instantanée. */
const useIdlePrefetchRoutes = (currentPath: string) => {
  useEffect(() => {
    const cancels = Object.entries(ROUTE_PRELOADERS)
      .filter(([path]) => path !== currentPath)
      .map(([, preload]) =>
        whenIdle(() => {
          preload().catch(() => undefined);
        }),
      );
    return () => cancels.forEach((cancel) => cancel());
  }, [currentPath]);
};

export const Layout = () => {
  const { pathname } = useLocation();
  useScrollTopOnNavigate(pathname);
  useIdlePrefetchRoutes(pathname);

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
      <CookieBanner />
    </div>
  );
};
